import { DeskLegsToSimpleSapElementMapper } from '../desk/deskLegsToSimpleSapElementMapper';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';
import Element from '@/models/element';

export class BedsideTableLegsToSimpleSapElementMapper
    extends DeskLegsToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const code = this.toLegsType(element);
        const dim1 = this.useOldCodes(code)
            ? 1
            : this.useStrangeCodes(code)
                ? 8
                : 6;
        const dim2 = this.useOldCodes(code)
            ? 3
            : this.useStrangeCodes(code)
                ? 1
                : 4;
        const type = this.formatType(code, dim1, dim2);
        return [SimpleSapElement.LEG(type, '')];
    }

    private useOldCodes(code: string): boolean {
        return (
            code === this.metalLegs ||
            code === 'SDKS' ||
            code === 'NDWS'
        );
    }

    private useStrangeCodes(code: string): boolean {
        return (
            code === 'NMWP'
        );
    }
}
